import React, { useEffect, useState } from "react";
import t from "prop-types";
import Row from "../../shared_modules/common/grid/Row";
import Col from "../../shared_modules/common/grid/Col";
import ValidationMsg from "../../shared_modules/common/forms/ValidationMsg";

const element = {
  name: "employmentStatus",
  prefix: "pf-contact-",
  id: "pf-contact-employment-status",
  label: "Employment Status",
  colLabelClassName: "label",
  colFieldClassName: "field",
  colValidationClassName: "messaging",
};
const defaultMsgData = {
  errors: { [element.name]: {} },
};
const msgDataWithError = {
  errors: {
    [element.name]: {
      id: element.id,
      slug: element.name,
      msg: "Please select an Employment Status",
      type: "error",
    },
  },
};
let options = [
  { label: "Select", value: "" },
  { label: "Employed", value: "EMPLOYED" },
  { label: "Self Employed", value: "SELFEMPLOYED" },
  { label: "Retired", value: "RETIRED" },
  { label: "Unemployed", value: "UNEMPLOYED" },
  { label: "Other", value: "OTHER" },
];
const colLayout = {
  1: { sm: 12, lg: 3 },
  2: { sm: 12, lg: 2 },
  3: { sm: 12, lg: 1 },
  4: { sm: 12, lg: 6 },
};

const EmploymentStatus = ({ fieldMetadata, onEventCallback, hasAutoFilled }) => {
  const [selectedItem, setSelectedItem] = useState(fieldMetadata.value);
  const handleChange = (e) => {
    const { value } = e.target;
    setSelectedItem(value);
    // As soon as the user selects an item,
    // there is no need to show the "Select" option
    options = options.filter((o) => o.value !== "");

    onEventCallback(e, {
      value,
      status: !!value ? "" : "invalid",
      isValid: !!value,
    });
  };

  useEffect(() => {
    const fEvent = {
      target: {
        name: 'employmentStatus',
      }
    };
    if (hasAutoFilled) {
      setSelectedItem(fieldMetadata.value);
      onEventCallback(fEvent, {
        value: fieldMetadata.value,
        status: "",
        isValid: true,
      });
    }
  }, [hasAutoFilled]);

  return (
    <Row className={element.prefix + element.name}>
      <Col className={element.colLabelClassName} width={colLayout[1]}>
        <label className="label-split" htmlFor={element.id}>
          <span className="text">{element.label}</span>
        </label>
      </Col>
      <Col className={element.colFieldClassName} width={colLayout[1]}>
        <select value={selectedItem} id={element.id} name={element.name} onChange={handleChange}>
          {options.map((o) => (
            <option key={o.label} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
      </Col>
      <Col className={element.colValidationClassName} width={colLayout[4]}>
        <ValidationMsg
          filterFields={[element.name]}
          msgs={
            (selectedItem === "" && fieldMetadata.status === "") ||
            selectedItem !== ""
              ? defaultMsgData
              : msgDataWithError
          }
        />
      </Col>
    </Row>
  );
};

EmploymentStatus.propTypes = {
  hasAutoFilled: t.bool.isRequired,
  fieldMetadata: t.object.isRequired,
  onEventCallback: t.func.isRequired,
};

export default EmploymentStatus;

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/pages/borrower-registration/styles/borrower-registration.scss');